<div class="relative">
  <button
    type="button"
    (click)="toggleDropdown()"
    class="dropdown-toggle flex min-w-0 items-center text-gray-700 dark:text-gray-400"
  >
    <span class="mr-2 h-10 w-10 shrink-0 overflow-hidden rounded-full xl:mr-3 xl:h-11 xl:w-11">
      <img src="/assets/user.png" alt="User" />
    </span>
    <span class="mr-1 hidden max-w-[115px] truncate font-medium text-theme-sm min-[480px]:block xl:max-w-[160px]">
      {{ displayName() }}
    </span>
    <svg
      [ngClass]="{
        'stroke-gray-500 dark:stroke-gray-400 transition-transform duration-200': true,
        'rotate-180': isOpen,
      }"
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.3125 8.65625L9 13.3437L13.6875 8.65625"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>

  <app-dropdown
    [isOpen]="isOpen"
    (close)="closeDropdown()"
    className="absolute right-0 mt-[17px] flex w-[260px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-theme-lg dark:border-gray-800 dark:bg-gray-dark"
  >
    <div class="border-b border-gray-200 pb-3 dark:border-gray-800">
      <span class="block font-medium text-gray-700 text-theme-sm dark:text-gray-400">
        {{ displayName() }}
      </span>
      <span class="mt-0.5 block truncate text-theme-xs text-gray-500 dark:text-gray-400">
        {{ email() || 'No email address' }}
      </span>
    </div>

    <button
      type="button"
      (click)="logout()"
      class="mt-3 flex items-center gap-3 rounded-lg px-3 py-2 text-left font-medium text-gray-700 text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300"
    >
      <svg
        class="fill-gray-500 dark:group-hover:fill-gray-300"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.1007 19.247C14.6865 19.247 14.3507 18.9112 14.3507 18.497V14.245H12.8507V18.497C12.8507 19.7396 13.8581 20.747 15.1007 20.747H18.5007C19.7434 20.747 20.7507 19.7396 20.7507 18.497V5.49609C20.7507 4.25345 19.7433 3.24609 18.5007 3.24609H15.1007C13.8581 3.24609 12.8507 4.25345 12.8507 5.49609V9.74501H14.3507V5.49609C14.3507 5.08188 14.6865 4.74609 15.1007 4.74609H18.5007C18.9149 4.74609 19.2507 5.08188 19.2507 5.49609V18.497C19.2507 18.9112 18.9149 19.247 18.5007 19.247H15.1007ZM3.25073 11.9984C3.25073 12.2144 3.34204 12.4091 3.48817 12.546L8.09483 17.1556C8.38763 17.4485 8.86251 17.4487 9.15549 17.1559C9.44848 16.8631 9.44863 16.3882 9.15583 16.0952L5.81116 12.7484H16.0007C16.4149 12.7484 16.7507 12.4127 16.7507 11.9984C16.7507 11.5842 16.4149 11.2484 16.0007 11.2484H5.81528L9.15585 7.90554C9.44864 7.61255 9.44847 7.13767 9.15547 6.84488C8.86248 6.55209 8.3876 6.55226 8.09481 6.84525L3.52309 11.4202C3.35673 11.5577 3.25073 11.7657 3.25073 11.9984Z"
          fill=""
        ></path>
      </svg>
      Sign out
    </button>
  </app-dropdown>
</div>
